<template>
  <v-card class="top-destination-card relative" @click="">
    <v-img :src="'/storage/' + destination.home_thumbnail_image" class="h-full" :alt="destination.landing_main_alt" cover>
      <v-card-text class="flex flex-col justify-center items-center h-full w-full gap-y-6">
        <span class="text-xl text-white font-black absolute top-6 left-0 right-0 mx-auto text-center"> {{ $t('top_destinations.round_trip_to') }} </span>
        <h3 class="text-3.5xl text-white text-center leading-8 font-black mt-5">{{ destination.name }}</h3>
        <v-card-actions>
          <v-btn @click="goToDestiny" class="top-destinations-btn absolute bottom-6 left-0 right-0 mx-auto bg-white text-black font-black rounded-4xl">
            {{ $t('shared.find_out') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-img>
  </v-card>
</template>

<script>
export default {
  props: {
    destination: Object,
  },
  methods: {
    goToDestiny() {
      this.$router.push({ name: "destiny", params: { slug: this.destination.slug } });
    }
  }
};
</script>

<style>
.top-destination-card {
  border-radius: 16px !important;
  height: 230px !important; 
}

.top-destinations-btn {
  height: 46px !important;
  box-shadow: unset !important;
  width: 144px;
  color: black !important;
  text-transform: none;
}
</style>
